export default __webpack_public_path__ + "static/media/Troopers_Overview_15Jun21.bb93100d.png";